<div class="activation">
    <div class="container reset-password-container">
      <div class="container-header no-bottom-border">
        <div class="text">User Activation</div>
      </div>
      <div *ngIf="!activated" class="container-content">
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="newPassword"
            placeholder="Set Your Password"
            [formGroup]="activateForm"
            type="password"
          >
          </lhpe-input>
        </div>
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="confirmNewPassword"
            placeholder="Confirm Your Password"
            [formGroup]="activateForm"
            type="password"
          >
          </lhpe-input>
        </div>
  
        <div class="container-row submit-row">
          <button
            mat-button
            color="lightGreen"
            [disabled]="activateForm.invalid"
            (click)="submitActivation()"
          >
            Submit
          </button>
        </div>
      </div>
      <div *ngIf="activated" class="container-content">
        <div class="container-row desc-row">
          User activated, please wait as we redirect you to the login
          page
        </div>
      </div>
    </div>
  </div>
  